import { Chip, ChipProps } from "@mui/material";

export default function CustomChip(props: ChipProps) {
    return <Chip variant="outlined" {...props} />;
}
